import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getAllUsers } from "../../../redux/userSlice/userSlice";
import MangerSelect from "../../Inputs/MangerSelect/MangerSelect";
import { ROLES } from "../../../constants/roles";
import { useNavigate, useParams } from "react-router-dom";
import notify from "../../../hooks/useNotifaction";
import { assignMangerAndStuffContract, assignMangerAndStuffSingleShedule, getAllMaintenanceScheduleById } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";

export default function AddMangerAndStuff() {
  const [users, setUsers] = useState({
    managerId: "",
    employeeId: "",
  });
  const navigate = useNavigate();
  const { specificMaintenanceSchedule } = useSelector((state) => state.maintenanceSchedule);
  const { ContractId, ScheduleId } = useParams();
  const { allUsers } = useSelector((state) => state.user);
  const stuffUsers = Array.isArray(allUsers)
    ? allUsers
        .filter((user) => user.role == ROLES.STAFF)
        .map((user) => ({
          label: user.name,
          value: user.id,
        }))
    : [];

  useEffect(() => {
    if (ScheduleId) {
      dispatch(getAllMaintenanceScheduleById(ScheduleId));
    }
  }, [ScheduleId]);
  useEffect(() => {
    if (specificMaintenanceSchedule) {
      setUsers({
        managerId: specificMaintenanceSchedule?.maintenance_manager_id,
        employeeId: specificMaintenanceSchedule?.assigned_to,
      });
    }
  }, [specificMaintenanceSchedule]);
  const selectedStuff = stuffUsers?.find((user) => user.value == users.employeeId);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllUsers({ page: 0 }));
  }, []);
  const handleChangeManger = useCallback((selected) => {
    setUsers((prev) => ({
      ...prev,
      managerId: selected,
    }));
  }, []);

  const handleChangeStuff = (selected) => {
    setUsers((pe) => ({
      ...pe,
      employeeId: selected.value,
    }));
  };
  const validationForm = () => {
    if (!users.employeeId) {
      notify("من فضلك قم بإختيار الموظف", "error");
      return false;
    }
    if (!users.managerId) {
      notify("من فضلك قم بإختيار المدير", "error");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validationForm()) return;
    try {
      let res;
      if (ContractId) {
        res = await dispatch(assignMangerAndStuffContract({ id: ContractId, data: users })).unwrap();
      } else if (ScheduleId) {
        res = await dispatch(assignMangerAndStuffSingleShedule({ id: ScheduleId, data: users })).unwrap();
      }
      navigate("/Tasks");
      notify(res?.message, "success");
    } catch (error) {
      notify(error?.message, "error");
    }
  };

  console.log(selectedStuff);
  // const ll = specificMaintenanceSchedule?.assignedTechnician?.find((user) => user.id == users.employeeId);

  return (
    <div className="main addContract">
      <h1 className="text-white">اضافة موظفين ومديرين</h1>
      <div className="card mt-5">
        <form onSubmit={handleSubmit}>
          <div className="mb-3 pt-5 pb-2 px-3 companyProfile">
            <section className="row mb-5">
              <div className="col-12 mt-3 mb-2">
                <label htmlFor="">اختر موظف</label>
                <Select
                  options={stuffUsers ? stuffUsers : []}
                  placeholder="اختر موظف"
                  isSearchable
                  value={selectedStuff}
                  menuPortalTarget={document.body}
                  onChange={handleChangeStuff}
                  classNames={{
                    control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
                  }}
                />
              </div>
              <div className="col-12 mt-3 mb-2">
                <MangerSelect onChange={handleChangeManger} value={users.managerId} users={allUsers} isDisabled={false} />
              </div>
            </section>
            <div>
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-plus me-1"></i>
                إضافة
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
